document.querySelectorAll('.ToggleInfoBlock--gray').forEach((el) => {
    el.querySelectorAll('input').forEach((input, i) => {
        input.addEventListener('change', () => {
            if(i) {
                addListeners();
            }
            else {
                removeListeners();
            }
        });
    });

    function getEls() {
        return document.querySelectorAll('.ApartmentItem');//, .HouseItem
    }

    function removeListeners() {
        getEls().forEach((el) => {
            el.removeEventListener('click', handleClick);
        })
    }
    function addListeners() {
        getEls().forEach((el) => {
            el.addEventListener('click', handleClick);
        })
    }

    function handleClick(e) {
        if(!window.$isMobile) {
            const item = e.target.closest('[data-url]');
            const isClickLink = e.target !== item && (e.target.tagName === 'A' || e.target.dataset['data-modal']);
            const isClickActions = e.target.closest('.ActionsList');
            if(item && !isClickLink && !isClickActions) {
                e.preventDefault();
                const iframe = document.querySelector('.ModalIframe iframe');
                iframe.src = item.dataset.url;
                openModal('.ModalIframe')
            }
        }
    }
});
